<template>
  <div class="withdraw-detail">
    <div class="header">
      <div class="title">提现</div>
    </div>
    <!-- 提现信息 -->
    <div class="session">
      <div class="title">提现信息</div>
      <el-form inline class="form">
        <el-form-item class="form-item" label="提现周期:">
          <el-input
            class="withdraw-input"
            v-model="withdrawData.date"
            auto-complete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item class="form-item" label="提现金额:">
          <el-input
            class="withdraw-input"
            v-model="withdrawData.incomeAmount"
            auto-complete="off"
            disabled
          ></el-input
          >元
        </el-form-item>
      </el-form>
    </div>
    <div class='session invoice-dialog'>
      <div class="title">开票信息</div>
      <el-form class="inline-form" inline style="margin-top: 20px">
        <el-form-item label="寄送信息:">
          <el-input
            type="textarea"
            class='sendInput'
            v-model="billTable.send"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="开票信息:">
          <el-input
            type="textarea"
            v-model="billTable.bill"
            style="width: 400px"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 发票信息 -->
    <div class="session billMessage">
      <div class="title">发票信息</div>
      <el-form inline class="form">
        <el-form-item class="form-item" label="发票金额:">
          <el-input
            class="withdraw-input"
            v-model="invoice.invoiceAmt"
            auto-complete="off"
          ></el-input
          >元
        </el-form-item>
        <el-form-item class="form-item" label="发票代码:">
          <el-input
            class="withdraw-input"
            v-model="invoice.invoiceCode"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item class="form-item number-item" label="发票号:">
          <el-input
            class="withdraw-input"
            v-model="invoice.invoiceNumber"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item class="form-item" label="开票日期:">
          <el-date-picker
            v-model="auditTime"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="form-item" label="发票内容:">
          <el-input
            class="withdraw-input"
            v-model="invoice.invoiceContent"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item class="form-item" label="发票税率:">
          <el-input
            class="withdraw-input"
            v-model="invoice.invoiceRate"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item class="form-item" label="发票照片:">
            <VueImgInputer v-model='file' theme="light" size="small" readonly-tip-text='' :readonly="true" placeholder="" class="imgPad" :onChange='getBase64'></VueImgInputer>
        </el-form-item>
      </el-form>
    </div>
    <!-- 快递信息 -->
    <div class="session">
      <div class="title">快递信息</div>
      <el-form inline class="form">
        <el-form-item class="form-item" label="快递公司:">
          <el-input
            class="withdraw-input"
            v-model="courier.expressCompany"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item class="form-item" label="快递单号:">
          <el-input
            class="withdraw-input"
            v-model="courier.expressCode"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="operator">
      <el-button type="primary" @click='submmitMessage'>提交</el-button>
    </div>
  </div>
</template>

<script>
import VueImgInputer from "vue-img-inputer";
import { getExtract, uploadMerchantPicture, getSendAndInvoiceInfo } from "@/api/data-report";
import { formatDate } from "@/utils/index";

export default {
  name: "withdrawDetail",
  components: {
    VueImgInputer,
  },
  data() {
    return {
      withdrawMessage: {
        date: "",
        extractAmt: "",
      },
      auditTime: '',
      invoice: {
        invoiceAmt: "",
        invoiceCode: "",
        invoiceNumber: "",
        invoiceDate: "",
        invoiceContent: "",
        invoiceRate: "",
        invociePicture: '',
      },
      courier: {
        expressCompany: "",
        expressCode: "",
      },
      billTable: {
        send: '',
        bill: '',
        receive: '',
        phoneNumber: '',
        address: '',
        taxCode: '',
        invoiceHeader: '',
      },
      supplyImgTemp: ['picture2/M00/00/61/CmAiBGFyI5SAE7HRAAAI4QPuuAE791.png'],
      isDisabled: false,
      file: '',
      base64: '',
      fileExt: '',
      withdrawData: JSON.parse(this.$route.query.data),
      // withdrawData: {},
    };
  },
  computed: {
    merchantId() {
      return localStorage.getItem("LOGIN_INFO") && JSON.parse(localStorage.getItem("LOGIN_INFO")).merchantId;
    },
    userName() {
      return localStorage.getItem("LOGIN_INFO") && JSON.parse(localStorage.getItem("LOGIN_INFO")).userName;
    },
    sessionId() {
      return localStorage.getItem("LOGIN_INFO") && JSON.parse(localStorage.getItem("LOGIN_INFO")).sessionId;
    },
  },
  methods: {
    uploadSuccessSupply(data) {
      const val = data.valueName;
      const path = data.path;
      this.pushImgSupply(val, path);
    },
    isEmpty(val) {
      if (typeof val === 'undefined' || val === 'null' || val === '') {
        return true;
      }
      return false;
    },
    submmitMessage() {
      if (this.auditTime) {
        this.invoice.invoiceDate = formatDate(this.auditTime);
      } else {
        this.invoice.invoiceDate = '';
      }
      const invoiceTmp = this.invoice;
      invoiceTmp.invoiceAmt *= 100;
      // 发票信息和快递信息不为空
      const temp = Object.assign(invoiceTmp, this.courier);
      try {
        Object.keys(temp).forEach((item) => {
          if (this.isEmpty(temp[item])) {
            this.$message({
              message: '必填信息未填写',
              type: 'error',
            });
            throw new Error();
          }
        });
        const param = {
          merchantId: this.merchantId,
          userName: this.userName,
          sessionId: this.sessionId,
          date: this.withdrawData.date,
          extractAmt: this.withdrawData.amount,
          receive: this.billTable.receive,
          phoneNumber: this.billTable.phoneNumber,
          address: this.billTable.address,
          taxCode: this.billTable.taxCode,
          invoiceHeader: this.billTable.invoiceHeader,
        };
        const params = Object.assign(param, this.invoice, this.courier);
        getExtract(params).then((res) => {
          if (res.data.error_code === 0) {
            this.$message({
              message: '提交成功',
              type: "success",
            });
            this.$router.push('/income-draw');
          } else {
            this.$message({
              message: res.data.error_msg,
              type: "error",
            });
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    getBase64() {
      const file = this.file;
      const fileName = file.name;
      if (fileName) {
        this.fileExt = fileName.substr(fileName.lastIndexOf(".") + 1);
      }
      const reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.base64 = reader.result.split(',')[1];
          const param = {
            merchantId: this.merchantId,
            userName: this.userName,
            sessionId: this.sessionId,
            picData: this.base64,
            ext: this.fileExt,
          };
          uploadMerchantPicture(param).then((res) => {
            if (res.data.error_code === 0) {
              this.invoice.invociePicture = res.data.data.pictureRealUrl;
            } else {
              this.$message({
                message: res.data.error_msg,
                type: "error",
              });
            }
          });
        };
      }
    },
    billSend() {
      const param = {
        merchantId: this.merchantId,
        userName: this.userName,
        sessionId: this.sessionId,
      };
      getSendAndInvoiceInfo(param).then((res) => {
        this.billTable.receive = res.data.data.receive;
        this.billTable.phoneNumber = res.data.data.phoneNumber;
        this.billTable.address = res.data.data.address;
        this.billTable.taxCode = res.data.data.taxCode;
        this.billTable.invoiceHeader = res.data.data.invoiceHeader;
        this.billTable.send = `收件人:${res.data.data.receive}\n联系手机:${res.data.data.phoneNumber}\n收货地址:${res.data.data.address}`;
        this.billTable.bill = `税号:${res.data.data.taxCode}\n抬头:${res.data.data.invoiceHeader}`;
      });
    },
  },
  mounted() {
    this.billSend();
  },
};
</script>

<style lang="scss" >
.withdraw-detail {
//   padding: 30px;
  padding-left: 50px;
  background-color: #fff;
  margin-bottom: 100px;
  > .header {
    margin-bottom: 30px;
    .title {
      height: 80px;
      line-height: 80px;
      color: #333333;
      font-size: 18px;
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 0px;
        border-bottom: 1px solid #f2f3f3;
        right: 0;
        bottom: 0;
        left: -50px;
        position: absolute;
        }
    }
  }
  .billMessage {
    width: 500px;
    img {
      height: 200px;
      width: 200px;
      object-fit:cover;
    }
  }
  .invoice-dialog {
    .sendInput {
      textarea {
        min-height: 90px !important;
      }
    }
  }
  .session {
    width: 400px;
    .title {
      font-size: 20px;
      padding-bottom: 20px;
    }
    .withdraw-input {
      width: 250px;
      input {
        padding: 20px;
      }
    }
    .form {
      padding-bottom: 30px;
      .form-item {
        label {
          padding-top: 7px;
        }
      }
      .number-item {
        label {
          padding-right: 25px;
        }
      }
    }
  }
}
</style>
